<ng-container *ngIf="{ toolbar: showToolbar$ | async } as config">
    <nirby-toolbar *ngIf="config.toolbar"></nirby-toolbar>
    <div
        class="app-container"
        [ngClass]="config.toolbar ? ['py-4', 'px-4', 'py-md-5'] : []"
    >
        <router-outlet></router-outlet>
    </div>
</ng-container>
